// Generated by `bazel run i18n`. Do not edit by hand.
import en from "./en/return-ui.json";

export default en;
